export default {
  StrokeColor: 'border',
  FillColor: 'fill',
  TextColor: 'text',
};